package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable
import kotlinx.datetime.Instant

@Serializable
data class SuperAdminRequest<T>(
    override val email: String,
    override val role: UserRole,
    override val request: T? = null,
): AuthenticatedEnvelope<T>

@Serializable
data class UserTestDataRequest(
    val testId: String
)

@Serializable
data class SupAdmVerifyRequest(val adminId: String)

@Serializable
data class MaintenanceStatusPayload(val isMaintenanceMode: Boolean)

@Serializable
data class MaintenanceToggleRequest(val enable: Boolean)

@Serializable
data class SupAdmGrantCreditRequest(
    val grantorEmail: String,
    val granteeEmail: String,
    val count: Int
)

@Serializable
data class SupAdmCreditStatistics (
    val total: Int? = null,
    val used: Int? = null,
    val active: Int? = null,
    val expired: Int? = null
)

@Serializable
data class SupAdmDataStatsPayload(
    val totalStud: Int,
    val totalTestSub: Int,
    val totalNeedVerify: Int,
    val adminNeedVerify: Int,
    val totalAdmin: Int,
    val creditStats: SupAdmCreditStatistics
)

@Serializable
data class Admin(
    val id: String,
    val name: String,
    val email: String,
    val nric: String,
    val address: String,
    val phone: String,
    val workType: String,
    val organizationId: String,
    val organizationName: String,
    val position: String,
    val isVerified: Boolean,
)

@Serializable
data class SupAdmAdminsInfoPayload(
    val admins: List<Admin>
)

@Serializable
data class UserTestInfoPayload(
    val answers: TestResultData,
    val nationalId: String
)

@Serializable
data class TestUser(
    val id: String,
    val testId: String,
    val name: String,
    val email: String,
    val status: TestSubmissionStatus,
    val phone: String,
    val submittedAt: Instant,
    val orgName: String? = null,
    val reportExpiresAt: Instant? = null,
    val reportRequested: Boolean = false
)

@Serializable
data class TestUsersPayload(
    val users: List<TestUser>
)

@Serializable
data class SelectedUser(
    val id: String,
    val name: String,
    val email: String,
    val testId: String,
    val phone: String,
    val ic: String,
    val answers: TestResultData,
    val submittedAt: Instant
)

@Serializable
data class SupAdmPaymentsDashRequest(
    val startDate: Instant? = null,
    val endDate: Instant? = null,
    val status: String? = null,
    val page: Int = 1,
    val limit: Int = 10
)

@Serializable
data class PaymentRecord(
    val id: String,
    val purchasedAmount: Int,
    val status: PaymentStatus,
    val purchaseAt: Instant,
    val toyyibpayId: String,
    val amountPaidCents: Int,
    val creditsPurchased: List<CreditInfo>,
    val organizationName: String?
)

@Serializable
data class SupAdmCreditsDashPayload(
    val payments: List<PaymentRecord>,
    val totalRecords: Long,
    val totalPages: Int
)